'use strict';

module.exports = function (h, classes, item) {
    if (classes.framework === 'bulma') {
        return item;
    }

    return h('li', [item]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/modules/dropdown-item-wrapper.js
// module id = HTMB
// module chunks = 0